import * as c from "./constant";

export const setCards = (cards) => ({
  type: c.SET_CARDS,
  cards,
});

export const setCardImages = (cardId, { front, back }) => ({
  type: c.SET_CARD_IMAGES,
  cardId,
  front,
  back,
});

export const clearCards = () => ({
  type: c.CLEAR_CARDS,
});

export const toggleDisplay = () => ({
  type: c.TOGGLE_DISPLAY,
});

export const setDisplayImage = (cardId) => ({
  type: c.SET_DISPLAY_IMAGE,
  cardId,
});

export const closeImage = () => ({
  type: c.CLOSE_IMAGE,
});

export const openImage = () => ({
  type: c.OPEN_IMAGE,
});

export const setCardError = (cardId, { error }) => ({
  type: c.SET_ERROR,
  cardId,
  error,
});
